// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1v_Xu","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1vtcM"};